/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkboardTaskOccurrence = {
  readonly workboard_task_id?: number;
  readonly occurrence_id?: number | null;
  occurrence_date: string;
  status?: WorkboardTaskOccurrence.status;
};
export namespace WorkboardTaskOccurrence {
  export enum status {
    PENDING = 'pending',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
  }
}
